module.exports = __webpack_public_path__ + "static/media/Camo-NYC-17_thumb.71fe582d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fabrics-prints/Camo-NYC-17_thumb.jpg
// module id = 156
// module chunks = 0